import REQUIRED_FIELDS from '@/pages/projects/REQUIRED_FIELDS';
import { site_state_$ilike } from '@/utils/query-helpers';
import usePagedQuery from '@/hooks/usePagedQuery';
import { STUDENT_IMPACT_MESSAGE, sumActualStudents } from '@/utils/studentImpact';

export default function useProjectStudentImpact(network, schoolStart, schoolEnd, state) {
  const projects = usePagedQuery('projects', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          // networkId: network?.id,
          ...site_state_$ilike(state),
          completed: true,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    }
  }, { source: 'states-year/useProjectStudentImpact', message: STUDENT_IMPACT_MESSAGE });

  const totalCount = sumActualStudents(projects.data);

  return [
    projects,
    totalCount
  ];
}
